@import '@hevoio/hevo-ui-toolkit/styles/variables';
@import 'variables';

.helpNotesMain {
  background-color: $secondary-bg;
  padding: $spacer $spacer * 1.25;
  border: $border-width solid $divider-color;
  border-radius: 0 $border-radius-md $border-radius-md 0;
  border-left: none;
  margin-top: $spacer * 2;
  margin-bottom: $spacer * 2;
  position: relative;

  & .helpNotesMainLeft {
    .helpNotesInfoIcon {
      font-size: $icon-size-base * 1.5;
      color: $help-notes-info-bg;
      margin-right: $spacer * 0.75;
    }
  }

  &-title {
    line-height: $spacer * 1.125;
    margin-right: $spacer * 2;
  }

  .expandIcon {
    position: absolute;
    top: $spacer * 1.3125;
    right: $spacer * 1.25;
    cursor: pointer;
    transition: transform 200ms ease-in;

    &.expanded {
      transform: rotateX(180deg);
    }
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: -1px;
    width: 4px;
    height: calc(100% + 2px);
    background-color: $help-notes-info-bg;
  }
}
